import React from "react";
import { Layout, Button, Progress, Space, Row,Col } from "antd";
import { SettingOutlined, BellOutlined } from "@ant-design/icons";
import { IonIcon } from "@ionic/react";
import { fastFood, giftOutline, imageOutline, radioOutline } from "ionicons/icons";

//
import AvatarDropdown from "./AvatarDropdown";

//
import metaData from "../../data/metaData";
import { useTranslation } from "react-i18next";

const { Header } = Layout;

const HeaderComponent = ({ collapsed, onCollapse }) => {
  const { t, i18n } = useTranslation();

  return (
    <Header
      style={{
        background: "#fff",
        padding: "0 16px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        zIndex: 1,
        width: "100%",
      }}
    >
      <Space>
        {/* <Button type="text">Portfolio</Button>
        <Button type="primary">Company setup</Button>
        <Progress percent={50} style={{ width: 200 }} /> */}
        
        <div></div>
      </Space>
      <Space>
        <Row align="middle">
          {/* <Space className="hover-wrapper">
            <SettingOutlined style={{ fontSize: "20px", padding: "0 1rem 0 1rem" }} />
          </Space> */}
          <AvatarDropdown style={{ padding: "0 1rem 0 1rem" }} isApprover={false}/>
        </Row>
      </Space>
    </Header>
  );
};

export default HeaderComponent;
